import VueRouter from 'vue-router'
import guard from '@/routes/guard'
import bus from '@/services/bus'
import {writeHistory} from '@/plugins/router-history'
import routes from '@/routes/routes'
import store from '@/store'
import {Message} from 'element-ui'
import authService from '@/services/auth'

// @ts-ignore
import messages from '@/lang/index'

const router = new VueRouter({
  routes,
  linkActiveClass: 'active'
})

// global guard
router.beforeEach(async (to, from, next) => {
  if (store.state.user.user && Object.keys(store.state.user.user).length) {
    store.dispatch('resp/find', {limit: 100, offset: 0, active: true})
  }

  if (to.query.resp_key) {
    try {
      let {auth, resp_id} = await store.dispatch('resp/key', to.query.resp_key)
      authService.setToken(auth)
      await store.dispatch('user/loadUser')
      next({name: 'respPage', params: {id: resp_id}})
    } catch (error) {
      Message.error(messages.polls.can_not_find_poll)
      next({path: '/'})
    }
  }
  await guard(to, from, next)
  bus.$emit('pathChanged')
})
router.afterEach(writeHistory)

export default router